import config from 'config'

export enum QueryKey {
  PROJECTS_LIST = 'PROJECTS_LIST',
  PROJECTS_STATUS = 'PROJECTS_STATUS',
  PROJECT_DETAIL = 'PROJECT_DETAIL',
  CREATE_PROJECT = 'CREATE_PROJECT',
  BRANCHES_LIST = 'BRANCHES_LIST',
  CREATE_BRANCH = 'CREATE_BRANCH',
  PATCH_BRANCH = 'PATCH_BRANCH',
  ENVIRONMENTS_LIST = 'ENVIRONMENTS_LIST',
  CREATE_ENVIRONMENT = 'CREATE_ENVIRONMENT',
  EDIT_ENVIRONMENT = 'EDIT_ENVIRONMENT',
  SECRET_REFERENCES = 'SECRET_REFERENCES',
  ENVIRONMENTS_AGENTS = 'ENVIRONMENTS AGENTS',
  SECRET_LOCATION = 'SECRET_LOCATION',
  SECRET_NAMES = 'SECRET_NAMES',
  SECRET_KEYS = 'SECRET_KEYS',
  SECRET_REFERENCE = 'SECRET_REFERENCE',
  WAREHOUSE_DEFAULTS = 'WAREHOUSE_DEFAULTS',
  CREATE_SCHEDULE = 'CREATE_SCHEDULE',
  JOBS_LIST = 'JOBS_LIST',
  SCHEDULES_LIST = 'SCHEDULES_LIST',
  CREATE_MHA = 'CREATE_MHA',
  MATILLION_HOSTED_AGENTS = 'MATILLION_HOSTED_AGENTS',
  SECRET_VALUE = 'SECRET_VALUE',
  PATCH_SECRET_VALUE = 'PATCH_SECRET_VALUE',
  ACCOUNT_MEMBERS_LIST = 'ACCOUNT_MEMBERS_LIST',
  PROJECT_MEMBERS_LIST = 'PROJECT_MEMBERS_LIST',
  NEW_PROJECT_ROLES = 'NEW_PROJECT_ROLES',
  REMOVE_PROJECT_MEMBERS = 'REMOVE_PROJECT_MEMBERS',
  CREATE_OAUTH = 'CREATE_OAUTH',
  COMPLETE_OAUTH = 'COMPLETE_OAUTH',
  OAUTH_SCHEMA = 'OAUTH_SCHEMA',
  CREATE_WAREHOUSE_PROVISIONING = 'CREATE_WAREHOUSE_PROVISIONING',
  WAREHOUSE_PROVISIONING = 'WAREHOUSE_PROVISIONING',
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  EDIT_SCHEDULE = 'EDIT_SCHEDULE',
  DATABRICKS_COMPUTE_RESOURCES = 'DATABRICKS_COMPUTE_RESOURCES'
}

export const API_BASE_URL = config.projectExplorer.apiBaseUrl

export const QUERY_SMART_RETRIES = 0
export const QUERY_SMART_TIMEOUT = 40 * 1000
